<template>
  <router-view></router-view>
</template>

<script>
import axios from "axios";
import qs from "qs";

export default {
  name: 'App',
  url: process.env.VUE_APP_BASE_URL,
  methods: {
    getEmployees(companyId) {
      const now = new Date(); // 获取当前日期
      return axios.get(process.env.VUE_APP_BASE_URL + '/user/getEmployees', {
        params: {
          companyId,
          startDate: new Date(now.getFullYear(), now.getMonth(), 1)
        }
      });
    },

    searchEmployees(name) {
      return axios.post(process.env.VUE_APP_BASE_URL + '/user/getUserListByName', qs.stringify({
        name
      }));
    },

    updateIssue(issueId, departmentId, onSuccess) {
      axios.post(process.env.VUE_APP_BASE_URL + '/activity/v2/updateIssue', {
        issueId: issueId,
        departmentId: departmentId
      }).then(res => {
        onSuccess(res.data.data)
      });
    },

    getIssueTypes() {
      return axios.post(process.env.VUE_APP_BASE_URL + '/company/getCompanyProblemTypeList')
    },

    addEmployee(phoneNumber, companyId, departmentId) {
      return axios.post(process.env.VUE_APP_BASE_URL + '/user/joinCompany', qs.stringify({
        phoneNumber: phoneNumber,
        companyId: companyId,
        departmentId: departmentId
      }));
    },

    getAllDepartmentsOfCompany(companyId) {
      return axios.post(process.env.VUE_APP_BASE_URL + '/department/getDepartments?companyId=' + companyId);
    },

    getSubDepartments(companyId, parentId) {
      return axios.post(process.env.VUE_APP_BASE_URL + '/department/getDepartments?parentId=' + parentId + '&companyId=' + companyId);
    },

    setEmployeeDepartment(userId, departmentId) {
      return axios.post(process.env.VUE_APP_BASE_URL + '/user/setDepartment', qs.stringify({
        userId: userId,
        departmentId: departmentId
      }));
    },

    getActivities(companyId) {
      return axios.get(process.env.VUE_APP_BASE_URL + '/activity/getActivities?sortBy=publish_date&ascOrDesc=desc&pageNum=0&pageSize=1000', qs.stringify({
        companyId
      }));
    },

    creatingIssue(userId, eventId, departmentId, leaderId, location, images, issueTypeId, describtion, finderId, deadline) {
      return axios.post(process.env.VUE_APP_BASE_URL + '/activity/newProblem', qs.stringify({
        user_id: userId,
        eventId: eventId,
        depId: departmentId,
        leaderId: leaderId,
        place: location,
        img: images[0] | '',
        img2: images[1] | '',
        img3: images[2] | '',
        img4: images[3] | '',
        stypeId: issueTypeId,
        desc: describtion,
        finderId: finderId,
        deadlineDate: deadline,
        tm: new Date().getTime()
      }));
    },

    async uploadFile(file, onSuccess, onError) {
      const fileExtension = file.file.name.substring(file.file.name.lastIndexOf('.'));

      const uploadParams = (await axios.post(process.env.VUE_APP_BASE_URL + '/qiniu/getUpToken', qs.stringify({
        suffix: fileExtension
      }))).data.data;

      const domain = uploadParams.domain;
      const token = uploadParams.token;
      const url = "http://upload.qiniup.com/putb64/-1";
      const xhr = new XMLHttpRequest();
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
          const response = JSON.parse(xhr.responseText)
          if (response.error) {
            onError(response.error)
          } else {
            onSuccess(domain + response.key)
          }
        }
      };
      xhr.open("POST", url, true);
      xhr.setRequestHeader("Content-Type", "application/octet-stream");
      xhr.setRequestHeader("Authorization", "UpToken " + token);
      xhr.send(file.content.split(',')[1]);
    },
    getCountOfAllIssues() {
      return axios.post(process.env.VUE_APP_BASE_URL + '/issue/getCountOfIssue', {})
    },
    getUser(userId) {
      let query = ''
      if (userId) {
        query = '?userId=' + userId
      }
      return axios.post(process.env.VUE_APP_BASE_URL + '/user/getUserInfo' + query, qs.stringify({
        userId: userId,
      }))
    },
    async getIssues(object, signal) {
      let response = await axios.post(process.env.VUE_APP_BASE_URL + '/issue/getIssues',
          (object), {signal: signal});
      if (response.data.code === "0") {
        for (let i = 0; i < response.data.data.list.length; i++) {
          response.data.data.list[i].issueStatusName = ['待解决', '待验收', '已验收'][response.data.data.list[i].issueStatus]
          response.data.data.list[i].tagType = ['danger', 'warning', 'success'][response.data.data.list[i].issueStatus]
        }
      }
      return response;
    },
  }
}
</script>

<style>
@import "~weui";
</style>
